import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { PaginationPipe, PaginationInterface } from "ng2-bs-pagination";
import { ConfigService } from '../shared/config.service';
import { UtilsService } from '../shared/utils.service';
import { ContentService } from '../shared/content.service';

@Component({
  selector: 'admin-search-results',
  template: require('./partials/search-results.html')
})
export class SearchResultsComponent {

    @Input() esContents: any;
    @Input() dbContents: any;
    @Input() pageSize: any;
    @Output() onSearch: EventEmitter<Object> = new EventEmitter<Object>();

    currentPage: number = 1;
    currentLanguage: string;

    constructor(private config: ConfigService, private contentService: ContentService, private utils: UtilsService, private router: Router, private route: ActivatedRoute) {}

    ngOnInit(){
        this.route.parent.params.subscribe(
            (params: Params) => {
                this.currentLanguage = params['lg'];
            }
        );
    }
    ngAfterContentChecked(){
        if(!this.currentLanguage)
            this.currentLanguage = this.config.data.APP.LANGUAGES.PREFERRED;
    }

    onStatusChange(status: any, item: any){
        item.active = status;
        this.contentService.saveContent('record', 'update', item).then(res =>{
            console.log("Content set to "+status);
        });
    }

    public onPageChange(event: any): void {
        this.currentPage = event.currentPage;
        let from = ( this.currentPage - 1 ) * this.pageSize;
        // Callback log
        this.onSearch.emit('page '+this.currentPage);
        // Nav
        let params = {};
        for(let qp in this.route.snapshot.queryParams){
            params[qp] = this.route.snapshot.queryParams[qp];
        }
        params['from'] = from; 
        this.router.navigate(['.'], { relativeTo: this.route, queryParams: params });
    
    };

 

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/search-results.component.ts